import React from 'react'
import {arrayToOptions} from './array-to-options.js'
import {Dropdown} from 'semantic-ui-react'

const statusOptions = arrayToOptions(['Pending', 'Processed', 'QB-Entered'])

const VpoStatusSelect = (status, fieldOnChange) => {
  return (
    <span style={{width: '225px', display: 'inline-block'}}>
      <Dropdown
        placeholder='Status - ALL' fluid selection multiple search options={statusOptions}
        onChange={fieldOnChange} name='status' value={status}/>
    </span>
  )
}

export default VpoStatusSelect
